import {SearchToSelect} from "../../../components";
import React, {useState} from "react";


function LanguageSelector({onSelectFunction, selectedValue}){
    const languages = [{name:"English", code:"en"}, {name:"French", code:"fr"}, {name:"Spanish", code: "es"}]
    const [currentSelection, setCurrentSelection] = useState(languages.find(x => x.code === selectedValue).name)
    const search = (query) => {
        const lowercase = query.toLowerCase();
        const choices = languages.filter(lng => lng.name.toLowerCase().includes(lowercase)).sort();
        return choices.map(obj => obj.name)
    };

    const somethingSelected = (selection) => {
        setCurrentSelection(selection)
        //Send back the language and code
        onSelectFunction(selection, languages.find(x => x.name === selection).code)
    }




    return <div>
        <SearchToSelect
            placeholder={"Select Language"}
            multi={false}
            disabled={false}
            options={languages.map(lng => lng.name)}
            onSelected={somethingSelected}
            getKey={x => x}
            getSearchResults={({query}) => search(query)}
            selected={currentSelection}
        />
    </div>

}

export default LanguageSelector;
